import ProfileLanguages from './ProfileLanguages.component';

export default ProfileLanguages;
